import Modal from './Modal.vue';
import { modalBus } from './bus';

/**
 * Local Vue 3 replacement for vue-js-modal (no Vue 3 release exists).
 * Same app-facing API: <modal name="...">, $modal.show(name), $modal.hide(name).
 */
export default {
	install(app) {
		app.component('modal', Modal);
		app.config.globalProperties.$modal = {
			show: (name, params) => modalBus.emit('modal', { name, action: 'show', params }),
			hide: (name) => modalBus.emit('modal', { name, action: 'hide' }),
		};
	},
};
